<template>
  <div>
    <header-bar>
      {{ type === 'album' ? 'アルバム（2曲以上）': 'シングル' }}配信
    </header-bar>
    <div class="page-block">
      <div class="page-block__heading page-block__heading--withbar">
        <h3 class="page-block__title">リリース情報登録 - リリース情報の登録</h3>
        <release-type-label :type="type" />
      </div>
      <div class="page-block__inner">
        <release-step-area :index="2">
          リリース情報の登録
        </release-step-area>
        <alert-view
          v-if="!realtimeValidation"
          :errors="errors" />
        <form class="form--error">
          <div class="form-wrap">
            <div
              v-if="type === 'single'"
              class="form-group">
              <div class="form-label">
                <label class="control-label">商品区分
                  <span class="req">＊</span>
                </label>
                <i
                  v-tooltip="spTooltipConfig(trackTooltipMessages.classification)"
                  class="sp-tooltip-icon">
                </i>
                <i
                  v-tooltip="pcTooltipConfig(trackTooltipMessages.classification)"
                  class="tooltip-icon">
                </i>
              </div>
              <div class="form-item">
                <div class="form-item-inline">
                  <div class="radio">
                    <label for="classification_original">
                      <input
                        id="classification_original"
                        v-model="item.classification"
                        type="radio"
                        name="classification"
                        :value="1"
                        checked
                        @change="onChangeClassification(1)">
                      <div class="option-input"></div> オリジナル
                    </label>
                  </div>
                  <div class="radio">
                    <label for="classification_cover">
                      <input
                        id="classification_cover"
                        v-model="item.classification"
                        type="radio"
                        name="classification"
                        :value="2"
                        @change="onChangeClassification(2)">
                      <div class="option-input"></div> カバー
                    </label>
                  </div>
                  <div class="radio">
                    <label for="classification_arrange">
                      <input
                        id="classification_arrange"
                        v-model="item.classification"
                        type="radio"
                        name="classification"
                        :value="3"
                        @change="onChangeClassification(3)">
                      <div class="option-input"></div> アレンジ
                    </label>
                  </div>
                  <div class="radio">
                    <label for="classification_public">
                      <input
                        id="classification_public"
                        v-model="item.classification"
                        type="radio"
                        name="classification"
                        :value="4"
                        @change="onChangeClassification(4)">
                      <div class="option-input"></div> パブリックドメイン
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="form-label">
                <label
                  v-tooltip="spTooltipConfig(tooltipMessages.title_ja)"
                  class="control-label"
                  for="title_ja">タイトル
                  <span class="req">＊</span>
                </label>
                <i
                  v-tooltip="spTooltipConfig(tooltipMessages.title_ja)"
                  class="sp-tooltip-icon">
                </i>
              </div>
              <div class="form-item">
                <input
                  id="title_ja"
                  v-model="item.title_ja"
                  v-tooltip="pcTooltipConfig(tooltipMessages.title_ja)"
                  class="form-control"
                  type="text"
                  @blur="onFieldChanged('title_ja')"
                  @input="findVersioWords()">
                <p
                  v-if="foundVersioWords"
                  class="error-text">
                  バージョン(Ver. / Remix / 2022 Remastered / Cover / Live 等)はタイトル欄では無くバージョン欄に登録してください。
                </p>
                <p
                  v-if="errors.title_ja"
                  class="error-text">
                  {{ errors.title_ja[0] }}
                </p>
              </div>
            </div>
            <div class="form-group">
              <div class="form-label">
                <label
                  v-tooltip="spTooltipConfig(tooltipMessages.title_kana)"
                  class="control-label"
                  for="title_kana">タイトル（カナ表記）
                  <span class="req">＊</span>
                </label>
                <i
                  v-tooltip="spTooltipConfig(tooltipMessages.title_kana)"
                  class="sp-tooltip-icon">
                </i>
              </div>
              <div class="form-item">
                <input
                  id="title_kana"
                  v-model="item.title_kana"
                  v-tooltip="pcTooltipConfig(tooltipMessages.title_kana)"
                  class="form-control"
                  type="text"
                  @blur="onFieldChanged('title_kana')">
                <p
                  v-if="errors.title_kana"
                  class="error-text">
                  {{ errors.title_kana[0] }}
                </p>
              </div>
            </div>
            <div class="form-group">
              <div class="form-label">
                <label
                  v-tooltip="spTooltipConfig(tooltipMessages.title_en)"
                  class="control-label"
                  for="title_en">タイトル（アルファベット表記）
                  <span class="req">＊</span>
                </label>
                <i
                  v-tooltip="spTooltipConfig(tooltipMessages.title_en)"
                  class="sp-tooltip-icon">
                </i>
              </div>
              <div class="form-item">
                <input
                  id="title_en"
                  v-model="item.title_en"
                  v-tooltip="pcTooltipConfig(tooltipMessages.title_en)"
                  class="form-control"
                  type="text"
                  @blur="onFieldChanged('title_en')">
                <p
                  v-if="errors.title_en"
                  class="error-text">
                  {{ errors.title_en[0] }}
                </p>
              </div>
            </div>
            <div class="form-group-wrap">
              <div class="form-group-wrap__version-title">
                バージョン
                <i
                  v-tooltip="spTooltipConfig(
                    isBtoB ? tooltipMessages.versions_b2b : tooltipMessages.versions_b2c
                  )"
                  class="sp-tooltip-icon">
                </i>
                <i
                  v-tooltip="pcTooltipConfig(
                    isBtoB ? tooltipMessages.versions_b2b : tooltipMessages.versions_b2c
                  )"
                  class="tooltip-icon">
                </i>
              </div>
              <div class="form-group-wrap__example">
                [例]： Live / Remix / 2022 Remastered / Cover / Ver. など
                <div
                  class="form-item-text"
                  style="margin-top:1em;">
                  オリジナル版と区別をするため、バージョンをご登録いただく必要がございます。
                  <br><br>
                  バージョンを登録した楽曲は、著作権管理サービスを利用できません。詳しくは<a
                    href="/client/faqs/179"
                    class="c-text-link"
                    target="_blank">こちら</a>
                </div>
              </div>
              <div
                v-if="version_status">
                <div class="form-group">
                  <div class="form-label">
                    <label
                      class="control-label"
                      for="version_ja">バージョン
                    </label>
                    <i
                      v-tooltip="spTooltipConfig(tooltipMessages.version_ja)"
                      class="sp-tooltip-icon">
                    </i>
                  </div>
                  <div class="form-item">
                    <input
                      id="version_ja"
                      v-model="item.version_ja"
                      v-tooltip="pcTooltipConfig(tooltipMessages.version_ja)"
                      class="form-control"
                      type="text"
                      placeholder="(例)Acoustic. Ver"
                      @blur="onFieldChanged('version_ja')">
                    <div
                      v-if="errors.version_ja"
                      class="error-text">
                      <p
                        v-for="message in errors.version_ja[0].split('\n')"
                        :key="message">
                        {{ message }}
                      </p>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <div class="form-label">
                    <label
                      class="control-label"
                      for="version_kana">バージョン（カナ表記）
                    </label>
                    <i
                      v-tooltip="spTooltipConfig(tooltipMessages.version_kana)"
                      class="sp-tooltip-icon">
                    </i>
                  </div>
                  <div class="form-item">
                    <input
                      id="version_kana"
                      v-model="item.version_kana"
                      v-tooltip="pcTooltipConfig(tooltipMessages.version_kana)"
                      class="form-control"
                      type="text"
                      placeholder="(例)アコースティックバージョン"
                      @blur="onFieldChanged('version_kana')">
                    <p
                      v-if="errors.version_kana"
                      class="error-text">
                      {{ errors.version_kana[0] }}
                    </p>
                  </div>
                </div>
                <div class="form-group">
                  <div class="form-label">
                    <label
                      class="control-label"
                      for="title_en">バージョン（アルファベット表記）
                    </label>
                    <i
                      v-tooltip="spTooltipConfig(tooltipMessages.version_en)"
                      class="sp-tooltip-icon">
                    </i>
                  </div>
                  <div class="form-item">
                    <input
                      id="version_en"
                      v-model="item.version_en"
                      v-tooltip="pcTooltipConfig(tooltipMessages.version_en)"
                      class="form-control"
                      type="text"
                      placeholder="(例)Acoustic. Ver"
                      @blur="onFieldChanged('version_en')">
                    <div
                      v-if="errors.version_en"
                      class="error-text">
                      <p
                        v-for="message in errors.version_en[0].split('\n')"
                        :key="message">
                        {{ message }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group-wrap__btn-wrap">
                <button
                  v-if="!version_status"
                  type="button"
                  class="c-btn c-btn--narrow"
                  @click.prevent="onVersionAddClicked">
                  追加
                  <span class="c-btn__icon-add">
                    <span></span>
                  </span>
                </button>
                <button
                  v-if="version_status && !versionAddedCover"
                  type="button"
                  class="c-btn c-btn--delete-large c-btn--narrow c-btn--right"
                  @click.prevent="onVersionDeleteClicked">
                  削除
                </button>
              </div>
            </div>
            <div class="form-group">
              <div class="form-label">
                <label
                  class="control-label"
                  for="genre1">ジャンル1
                  <span class="req">＊</span>
                  <i
                    v-tooltip="pcTooltipConfig(tooltipMessages.genre1)"
                    class="tooltip-icon">
                  </i>
                  <i
                    v-tooltip="spTooltipConfig(tooltipMessages.genre1)"
                    class="sp-tooltip-icon">
                  </i>
                </label>
              </div>
              <div class="form-item">
                <div class="form-item-inline">
                  <div class="c-select_wrap">
                    <select
                      id="genre1"
                      v-model="item.genre1"
                      class="form-control c-select">
                      <option
                        v-for="(genre, genreId) in genres"
                        :key="genreId"
                        :value="genreId">
                        {{ genre }}
                      </option>
                    </select>
                  </div>
                  <p
                    v-if="errors.genre1"
                    class="error-text">
                    {{ errors.genre1[0] }}
                  </p>
                </div>
                <div
                  v-if="hasSoundTracks1"
                  class="error-text">
                  収録楽曲がタイアップ音源ではない・実際に映像作品等で使用されていない場合、ジャンルに「サウンドトラック」を選択することができません。
                  その場合は他のジャンルを選択してください。
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="form-label">
                <label
                  class="control-label"
                  for="genre2">ジャンル2
                  <i
                    v-tooltip="pcTooltipConfig(tooltipMessages.genre2)"
                    class="tooltip-icon">
                  </i>
                  <i
                    v-tooltip="spTooltipConfig(tooltipMessages.genre2)"
                    class="sp-tooltip-icon">
                  </i>
                </label>
              </div>
              <div class="form-item">
                <div class="form-item-inline">
                  <div class="c-select_wrap">
                    <select
                      id="genre2"
                      v-model="item.genre2"
                      class="form-control c-select">
                      <option
                        v-for="(genre, genreId) in genres"
                        :key="genreId"
                        :value="genreId">
                        {{ genre }}
                      </option>
                    </select>
                  </div>
                  <p
                    v-if="errors.genre2"
                    class="error-text">
                    {{ errors.genre2[0] }}
                  </p>
                </div>
                <div
                  v-if="hasSoundTracks2"
                  class="error-text">
                  収録楽曲がタイアップ音源ではない・実際に映像作品等で使用されていない場合、ジャンルに「サウンドトラック」を選択することができません。
                  その場合は他のジャンルを選択してください。
                </div>
              </div>
            </div>
            <div
              v-if="isBtoC && !isNarasuMate"
              class="form-group">
              <div class="form-label">
                <label
                  class="control-label"
                  for="label_name_ja">レーベル名
                  <i
                    v-tooltip="spTooltipConfig(tooltipMessages.label_ja)"
                    class="sp-tooltip-icon">
                  </i>
                </label>
                <i
                  v-tooltip="pcTooltipConfig(tooltipMessages.label_ja)"
                  class="tooltip-icon">
                </i>
              </div>
              <div class="form-item">
                <div class="form-item-text">
                  レーベルに所属されている方は、レーベル名をご記入ください。
                  レーベルに未所属の場合はアーティスト名が表示されます。
                  著作権欄にもレーベル名（アーティスト名）が表示されます。
                </div>
                <input
                  id="label_name_ja"
                  v-model="item.label_name_ja"
                  v-tooltip="pcTooltipConfig(tooltipMessages.label_name_ja)"
                  class="form-control"
                  type="text">
                <p
                  v-if="errors.label_name_ja"
                  class="error-text">
                  {{ errors.label_name_ja[0] }}
                </p>
              </div>
            </div>
            <div
              v-if="isBtoC && isNarasuMate"
              class="form-group">
              <div class="form-label">
                <label
                  class="control-label"
                  for="label">レーベル名
                </label>
              </div>
              <div class="form-item">
                <div class="form-item-inline">
                  <div class="c-select_wrap">
                    <!-- narasuMateユーザーはレーベル名を「narasuMate」に固定するため、選択肢はnarasuMateのみ -->
                    <select
                      id="label"
                      v-model="item.label_id"
                      class="form-control c-select"
                      :disabled="narasuMateLabels.length <= 1">
                      <option
                        v-for="label in narasuMateLabels"
                        :key="label.id"
                        :value="label.id">
                        {{ label.name }}
                      </option>
                    </select>
                  </div>
                  <p
                    v-if="errors.label_id"
                    class="error-text">
                    {{ errors.label_id[0] }}
                  </p>
                </div>
              </div>
            </div>
            <div
              v-if="isBtoB && !isCplus"
              class="form-group">
              <div class="form-label">
                <label
                  class="control-label"
                  for="label">レーベル
                </label>
                <i
                  v-tooltip="spTooltipConfig(tooltipMessages.label_ja)"
                  class="sp-tooltip-icon">
                </i>
              </div>
              <div class="form-item">
                <div class="form-item-inline">
                  <div class="c-select_wrap">
                    <select
                      id="label"
                      v-model="item.label_id"
                      class="form-control c-select"
                      :disabled="labels.length === 1">
                      <option
                        v-for="label in labels"
                        :key="label.id"
                        :value="label.id">
                        {{ label.name }}
                      </option>
                    </select>
                  </div>
                  <p
                    v-if="errors.label_id"
                    class="error-text">
                    {{ errors.label_id[0] }}
                  </p>
                </div>
              </div>
            </div>
            <div
              v-if="isBtoB && isCplus"
              class="form-group">
              <div class="form-label">
                <label
                  class="control-label"
                  for="label_name_ja">レーベル名
                  <i
                    v-tooltip="spTooltipConfig(tooltipMessages.label_ja)"
                    class="sp-tooltip-icon">
                  </i>
                </label>
                <i
                  v-tooltip="pcTooltipConfig(tooltipMessages.label_ja)"
                  class="tooltip-icon">
                </i>
              </div>
              <div class="form-item">
                <input
                  id="label_name_ja"
                  v-model="item.label_name_ja"
                  v-tooltip="pcTooltipConfig(tooltipMessages.label_name_ja)"
                  class="form-control"
                  type="text">
                <p
                  v-if="errors.label_name_ja"
                  class="error-text">
                  {{ errors.label_name_ja[0] }}
                </p>
              </div>
            </div>
            <div class="form-group">
              <div class="form-label">
                <label
                  class="control-label"
                  for="jan">JANコード
                  <i
                    v-tooltip="pcTooltipConfig(
                      isBtoC?tooltipMessages.jan:tooltipMessages.jan_tob,
                      true)"
                    class="tooltip-icon">
                  </i>
                  <i
                    v-tooltip="spTooltipConfig(isBtoC?tooltipMessages.jan:tooltipMessages.jan_tob)"
                    class="sp-tooltip-icon">
                  </i>
                </label>
              </div>
              <div class="form-item">
                <input
                  id="jan"
                  v-model="item.jan"
                  class="form-control"
                  type="text"
                  maxlength="13">
                <p
                  v-if="errors.jan"
                  class="error-text">
                  {{ errors.jan[0] }}
                </p>
              </div>
            </div>
            <div class="form-group">
              <div class="form-label">
                <label class="control-label">発売実績
                  <span class="req">＊</span>
                  <i
                    v-tooltip="pcTooltipConfig(
                      isBtoC?tooltipMessages.launched:tooltipMessages.launched_tob,
                      true)"
                    class="tooltip-icon">
                  </i>
                  <i
                    v-tooltip="spTooltipConfig(isBtoC?tooltipMessages.launched:
                      tooltipMessages.launched_tob)"
                    class="sp-tooltip-icon">
                  </i>
                </label>
              </div>
              <div class="form-item">
                <div class="form-item-text">
                  現在登録を行っている商品を、過去にCDなどで発売したことがある場合「あり」を選択してください。
                </div>
                <div class="form-item-inline">
                  <span class="radio">
                    <label for="released">
                      <input
                        id="released"
                        v-model="item.released"
                        name="released"
                        type="radio"
                        :value="1"
                        checked
                        @change="addOriginalReleaseDate">
                      <div class="option-input"></div> あり
                    </label>
                  </span>
                  <span class="radio">
                    <label for="no_released">
                      <input
                        id="no_released"
                        v-model="item.released"
                        name="released"
                        type="radio"
                        :value="0"
                        @change="initOriginalReleaseDate">
                      <div class="option-input"></div> なし
                    </label>
                  </span>
                </div>
                <p
                  v-if="errors.released"
                  class="error-text">
                  {{ errors.released[0] }}
                </p>
              </div>
            </div>
            <div
              v-if="item.released"
              class="form-group">
              <div class="form-label">
                <label class="control-label">
                  発売日
                  <span class="req">＊</span>
                </label>
              </div>
              <div class="form-item">
                <date-select
                  v-model="item.original_release_date"
                  max-date="2030-12-31" />
                <p
                  v-if="errors.original_release_date"
                  class="error-text">
                  {{ errors.original_release_date[0] }}
                </p>
              </div>
            </div>

            <div
              v-if="isBtoB"
              class="form-group">
              <div class="form-label">
                <label
                  class="control-label"
                  for="copyright_p">著作権表記(C)
                  <span class="req">＊</span>
                  <i
                    v-tooltip="pcTooltipConfig(
                      tooltipMessages.copyright_c,
                      true)"
                    class="tooltip-icon">
                  </i>
                  <i
                    v-tooltip="spTooltipConfig(tooltipMessages.copyright_c)"
                    class="sp-tooltip-icon">
                  </i>
                </label>
              </div>
              <div class="form-item">
                <input
                  id="copyright_c"
                  v-model="item.copyright_c_copyright"
                  v-tooltip="pcTooltipConfig(tooltipMessages.copyright_c_ja)"
                  class="form-control copyright-form-control"
                  type="text"
                  placeholder="XXXXX Records"
                  @blur="onFieldChanged('copyright_c_copyright')">
                <p
                  v-if="errors.copyright_c_copyright"
                  class="error-text">
                  {{ errors.copyright_c_copyright[0] }}
                </p>
              </div>
              <div class="form-item-inline form-item-inline--year">
                <input
                  id="copyright_c_year"
                  v-model="item.copyright_c_year"
                  class="form-control copyright-year-form-control"
                  type="text"
                  maxlength="4"
                  placeholder="2020"
                  @blur="onFieldChanged('copyright_c_year')">
                <p
                  v-if="errors.copyright_c_year"
                  class="error-text">
                  {{ errors.copyright_c_year[0] }}
                </p>
              </div>
            </div>

            <div
              v-if="isBtoB"
              class="form-group">
              <div class="form-label">
                <label
                  class="control-label"
                  for="copyright_p">原盤権表記(P)
                  <span class="req">＊</span>
                  <i
                    v-tooltip="pcTooltipConfig(
                      tooltipMessages.copyright_p,
                      true)"
                    class="tooltip-icon">
                  </i>
                  <i
                    v-tooltip="spTooltipConfig(tooltipMessages.copyright_p)"
                    class="sp-tooltip-icon">
                  </i>
                </label>
              </div>
              <div class="form-item">
                <input
                  id="copyright_p"
                  v-model="item.copyright_p_copyright"
                  v-tooltip="pcTooltipConfig(tooltipMessages.copyright_p_ja)"
                  class="form-control copyright-form-control"
                  type="text"
                  placeholder="XXXXX Records."
                  @blur="onFieldChanged('copyright_p_copyright')">
                <p
                  v-if="errors.copyright_p_copyright"
                  class="error-text">
                  {{ errors.copyright_p_copyright[0] }}
                </p>
              </div>
              <div class="form-item-inline form-item-inline--year">
                <input
                  id="copyright_p_year"
                  v-model="item.copyright_p_year"
                  class="form-control copyright-year-form-control"
                  type="text"
                  maxlength="4"
                  placeholder="2020"
                  @blur="onFieldChanged('copyright_p_year')">
                <p
                  v-if="errors.copyright_p_year"
                  class="error-text">
                  {{ errors.copyright_p_year[0] }}
                </p>
              </div>
            </div>
          </div>
        </form>
        <div class="c-btn-wrap">
          <a
            class="c-btn"
            @click.prevent="onRegisterClicked()">
            登録する
            <span class="c-btn__icon-arrow"></span>
          </a>
          <a
            class="c-btn c-btn--back c-btn--back-left"
            href="#"
            @click.prevent="onReturnClicked">
            リリース登録情報に戻る
            <span class="c-btn__icon-arrow c-btn__icon-arrow--left"></span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import ReleaseStepArea from '../StepArea'
import HeaderBar from '../../HeaderBar'
import ReleaseTypeLabel from '../ReleaseTypeLabel'
import DateSelect from '../../DateSelect'
import AlertView from '../../AlertView'
import tooltip from '../../../mixins/tooltip'
import tooltipMessages from './product-tooltips'
import trackTooltipMessages from './track-tooltips'

let vTimer = null
export default {
  name: 'ReleaseStep2Product',
  components: {
    DateSelect,
    HeaderBar,
    ReleaseStepArea,
    AlertView,
    ReleaseTypeLabel,
  },
  mixins: [
    tooltip,
  ],
  props: {
    tooltipMessages: {
      type: Object,
      default: () => tooltipMessages,
    },
    trackTooltipMessages: {
      type: Object,
      default: () => trackTooltipMessages,
    },
  },
  data() {
    return {
      item: {
        classification: 1,
        permission_cover_music: '',
        title_ja: '',
        title_en: '',
        title_kana: '',
        version_ja: '',
        version_kana: '',
        version_en: '',
        genre1: '',
        genre2: '',
        label_name_ja: '',
        label_name_en: '',
        label_id: '',
        jan: '',
        released: 0,
        original_release_date: '',
        remarks_ja: '',
        remarks_en: '',
        copyright_p_copyright: '',
        copyright_p_year: '',
        copyright_c_copyright: '',
        copyright_c_year: '',
      },
      validated: false,
      errors: [],
      genres: [],
      labels: [],
      type: '',
      version_status: false,
      realtimeValidation: true,
      versionAddedCover: false,
      foundVersioWords: false,
    }
  },
  computed: {
    // ユーザが法人かどうか
    isCompany() {
      return !this.$store.state.auth.company.is_consumer
    },
    // CPlusの法人かどうか
    isCplus() {
      return this.$store.state.auth.company.is_cplus
    },
    // narasuMateユーザーかどうか
    isNarasuMate() {
      return !!this.$store.state.auth.is_mate
    },
    // narasuMateユーザーが選択可能なレーベル(名称が「narasuMate」のもののみ)
    narasuMateLabels() {
      return this.labels.filter(label => label.name === 'narasuMate')
    },
    // サウンドトラックのジャンルを含むかどうか
    hasSoundTracks() {
      return this.hasSoundTracks1 || this.hasSoundTracks2
    },
    hasSoundTracks1() {
      return this.item.genre1 === 'Soundtrack'
    },
    hasSoundTracks2() {
      return this.item.genre2 === 'Soundtrack'
    },
  },
  mounted() {
    // ジャンルを初期化
    this.fetchGenres()
    // レーベル情報を初期化
    this.fetchLabels()
    // セッションから復元
    const release = JSON.parse(window.sessionStorage.getItem('album'))
    if (!release) {
      this.$router.push({ name: 'index' })
      return
    }
    this.type = release.type
    if (release.product.is_draft < 2) {
      this.item = release.product
      this.item.released = parseInt(this.item.released, 10)
    }
    // シングルの場合は楽曲の1曲目の区分を商品区分として扱う
    if (this.type === 'single' && release.discs[0].tracks[0]) {
      this.item.classification = release.discs[0].tracks[0].classification ?? 1
      if (this.item.classification === 2 || this.item.classification === 3) {
        this.item.permission_cover_music = 1
      }
      if (this.item.classification === 2) {
        this.version_status = true
        this.versionAddedCover = true
      }
    }
    // バージョンにカバーの文字がすでに入っている場合
    if (this.item.version_ja && this.item.version_ja.indexOf('カバー') !== -1) {
      this.version_status = true
      this.versionAddedCover = true
    }
    // バージョンの情報取得したときに中身があるときの処理
    this.versionContentsCheck()
  },
  methods: {
    // ジャンルマスタを取得
    async fetchGenres() {
      const { data } = await window.axios.get('/api/client/genres')
      this.genres = {
        '': '選択してください',
        ...data,
      }
    },
    // 所属レーベル情報を取得
    async fetchLabels() {
      const { data } = await window.axios.get('/api/client/labels')
      this.labels = data
      if (this.isNarasuMate) {
        // 下書き等でnarasuMateレーベル以外が設定されている場合はnarasuMateレーベルを選択する
        const isSelectable = this.narasuMateLabels.some(label => label.id === this.item.label_id)
        if (!isSelectable && this.narasuMateLabels.length >= 1) {
          this.item.label_id = this.narasuMateLabels[0].id
        }
        return
      }
      if (this.labels && this.labels.length >= 1 && !this.item.label_id) {
        this.item.label_id = this.labels[0].id
      }
    },
    // 戻るボタンクリック
    onReturnClicked() {
      window.scrollTo(0, 0)
      this.$router.push({ name: `${this.$route.meta.sideMenuId}-step2` })
    },
    onFieldChanged(key) {
      if (vTimer) {
        clearTimeout(vTimer)
      }
      vTimer = setTimeout(() => { this.onRegisterClicked(key) }, 500)
    },
    compileFormData(confirmed) {
      const keys = [
        'id',
        'classification',
        'permission_cover_music',
        'title_ja',
        'title_en',
        'title_kana',
        'version_ja',
        'version_kana',
        'version_en',
        'genre1',
        'genre2',
        'label_name_ja',
        'label_name_en',
        'label_id',
        'jan',
        'released',
        'original_release_date',
        'remarks_ja',
        'remarks_en',
        'copyright_p_copyright',
        'copyright_p_year',
        'copyright_c_copyright',
        'copyright_c_year',
      ]
      const params = this.item
      params.confirmed = confirmed
      const formData = new FormData()

      Object.keys(params)
        .filter(key => (keys.indexOf(key) !== -1))
        .forEach(key => {
          formData.append(key, params[key] !== null ? params[key] : '')
        })

      formData.append('_method', 'put')

      return formData
    },
    // 登録ボタンクリック
    async onRegisterClicked(key = null) {
      if (vTimer) {
        clearTimeout(vTimer)
      }
      if (this.hasSoundTracks && !this.version_status) {
        this.version_status = true
      }
      const config = { headers: { 'X-CMAP-No-Loading': 1, 'content-type': 'multipart/form-data' } }
      const release = JSON.parse(window.sessionStorage.getItem('album'))
      const formData = this.compileFormData(true)
      try {
        const { id } = release.product
        const { data } = await window.axios.post(`/api/client/products/${id}`, formData, config)
        // セッションデータに保存
        release.product = data
        if (this.type === 'single') {
          if (!release.discs[0].tracks[0]) {
            const artists = await this.fetchProductArtists(id)
            this.$set(release.discs[0].tracks, 0, {
              title_ja: null,
              title_kana: null,
              title_en: null,
              classification: 1,
              track_index: 0,
              version_ja: null,
              version_kana: null,
              version_en: null,
              main_artists: artists,
              featuring_artists: [],
              copyright_artists: [],
              filename: null,
              vocal: 1,
              parental_warning: 'no-explicit',
              language: 'ja',
              copyright_group: '7',
              prefix: '3',
              trial_start_min: 0,
              trial_start_sec: 0,
              is_omnibus: 0,
            })
          }
          release.discs[0].tracks[0].title_ja = this.item.title_ja
          release.discs[0].tracks[0].title_kana = this.item.title_kana
          release.discs[0].tracks[0].title_en = this.item.title_en
          release.discs[0].tracks[0].classification = parseInt(this.item.classification, 10)
          release.discs[0].tracks[0].version_ja = this.item.version_ja
          release.discs[0].tracks[0].version_kana = this.item.version_kana
          release.discs[0].tracks[0].version_en = this.item.version_en

          if (this.item.classification !== 1) {
            // eslint-disable-next-line no-underscore-dangle, max-len
            const youtubeIndex = this.getYoutubeRestrictionIndex(release.discs[0].tracks[0]._restrictions)
            if (youtubeIndex !== -1) {
              // eslint-disable-next-line no-underscore-dangle, max-len
              release.discs[0].tracks[0]._restrictions[youtubeIndex].settings.contents_id_enabled = 0
            }
            release.discs[0].tracks[0].contents_id_enabled = 0
            release.discs[0].tracks[0].freetrack = ''
            if (this.isBtoC) {
              release.discs[0].tracks[0].use_copyright_free = ''
              release.discs[0].tracks[0].has_sold_copyright_free = ''
            }
          }
        }
        window.sessionStorage.setItem('album', JSON.stringify(release))

        if (key) {
          this.errors = {}
        } else {
          this.onReturnClicked()
        }
      } catch ({ response }) {
        const { errors } = response.data
        if (key && !errors.status) {
          this.realtimeValidation = true
          this.$set(this.errors, key, errors[key])
        } else {
          this.realtimeValidation = false
          this.errors = errors
          window.scrollTo(0, 0)
        }
      }
      this.setErrorInput()
    },
    // アーティスト情報の取得と初期値のセット
    async fetchProductArtists(productId) {
      const { data } = await window.axios.get(`/api/client/products/${productId}/artists`)
      const artists = []
      data.forEach(item => {
        artists.push({
          id: item.id,
          type: item.type ?? null,
          company_id: item.company_id ?? null,
          image_path: item.image_path ?? null,
          name_ja: item.type === 2 ? '' : item.name_ja,
          name_kana: item.type === 2 ? '' : item.name_kana,
          name_en: item.type === 2 ? '' : item.name_en,
        })
      })
      return artists
    },
    // バージョン追加クリック
    onVersionAddClicked() {
      this.version_status = true
    },
    // バージョン削除クリック
    onVersionDeleteClicked() {
      this.versionAddedCover = false
      this.version_status = false
      this.item.version_ja = ''
      this.item.version_kana = ''
      this.item.version_en = ''
    },
    versionContentsCheck() {
      if (this.item.version_ja !== '' && this.item.version_ja !== null) {
        this.version_status = true
      }
    },
    findVersioWords() {
      if (this.item.title_ja.match(/\b(Remix|Remastered|Cover|Live)\b/i) || this.item.title_ja.match(/\bVer\./i)) {
        this.foundVersioWords = true
      } else {
        this.foundVersioWords = false
      }
    },
    initOriginalReleaseDate() {
      this.item.original_release_date = ''
    },
    addOriginalReleaseDate() {
      this.item.original_release_date = moment().format('Y-MM-DD')
    },
    setErrorInput() {
      document.querySelectorAll('.error-input').forEach(input => {
        input.classList.remove('error-input')
      })
      setTimeout(() => {
        const errorText = document.querySelectorAll('.error-text')
        if (errorText) {
          errorText.forEach(text => {
            text.previousElementSibling.classList.add('error-input')
          })
        }
      }, 100)
    },
    onChangeClassification(value) {
      this.item.permission_cover_music = ''

      if (value !== 2) {
        if (this.versionAddedCover) {
          this.item.version_ja = (this.item.version_ja.replace('カバー', '')).trim()
          this.item.version_kana = this.item.version_kana.replace('カバー', '')
          this.item.version_en = (this.item.version_en.replace('cover', '')).trim()
          this.versionAddedCover = false
          if (this.item.version_ja === '') this.version_status = false
        }
      } else if (!this.item.version_ja || (this.item.version_ja.indexOf('カバー') === -1 && this.item.version_ja.toLowerCase().indexOf('cover') === -1)) {
        this.item.version_ja = this.item.version_ja ? this.item.version_ja : ''
        this.item.version_ja = (`${this.item.version_ja} カバー`).trim()
        this.item.version_kana = this.item.version_kana ? this.item.version_kana : ''
        if (this.item.version_kana.indexOf('カバー') === -1) this.item.version_kana += 'カバー'
        this.item.version_en = this.item.version_en ? this.item.version_en : ''
        if (this.item.version_en.indexOf('cover') === -1) this.item.version_en = (`${this.item.version_en} cover`).trim()
        this.version_status = true
        this.versionAddedCover = true
      }
      // カバーアレンジの場合に権利書類設定
      if ([2, 3].includes(value)) {
        this.item.permission_cover_music = 1
      }
      this.onFieldChanged('classification')
    },

    getYoutubeRestrictionIndex(restrictions) {
      return restrictions?.findIndex(item => item.provider?.key === 'youtube') ?? -1
    },
  },
}
</script>

<style scoped>

@media screen and (min-width: 896px) {
  .copyright-form-control {
    width: 80%;
  }
}

</style>
